<template>
    <v-card>

        <v-card-title v-if="title">
            {{title}}
        </v-card-title>

        <div class="pa-5">
            {{message}}
        </div>

        <template v-if="vertical === true">
            <div class="d-flex align-center justify-center">
                <v-btn depressed color="primary" @click.stop="accept">{{acceptText}}</v-btn>
            </div>
            <div v-if="rejectText" class="d-flex align-center justify-center pa-5">
                <v-btn text color="primary" @click.stop="reject">{{rejectText}}</v-btn>
            </div>
        </template>

        <v-card-actions v-else class="justify-end"> 
            <v-btn depressed color="primary" @click.stop="accept">{{acceptText}}</v-btn>
            <v-btn  v-if="rejectText" text color="primary" @click.stop="reject">{{rejectText}}</v-btn>
        </v-card-actions>
        
    </v-card>
</template>

<script>
    export default {
        props: {
            vertical: Boolean,
            title: String,
            message: String,
            acceptText: {
                type: String,
                require: false,
                default: 'Ok'
            },
            rejectText: String
        },
        methods: {
            accept() {
                this.$eventBus.$emit('modal:close')
                this.$emit('accept')
            },
            reject() {
                this.$eventBus.$emit('modal:close')
                this.$emit('reject')
            }
        }
    }
</script>

<style>

</style>